<script lang="ts">
	import { ControlsContainer, DeviceButton, DeviceButtonV2, Text } from '@Shelly/shelly-design-system';
		import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { format } from 'svelte-i18n';
	import { beforeUpdate } from 'svelte';
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	import { real_id } from 'src/helpers/interface_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	let className = 'mb-s';
	export { className as class };
	export let device;

	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;

	let hasAlarm;
	let isMuted;
	beforeUpdate(() => {
		hasAlarm = status?.[`smoke:${device.channel}`]?.alarm; //Smoke is detected
		isMuted = status?.[`smoke:${device.channel}`]?.mute; //Smoke is detected but current alarm is muted(from
	});
	const muteAlarm = async () => {
		const res = await gen2Request(device, 'Smoke.Mute', { id: device.channel }, false);
		if (res.isok) {
			//Todo what to ?? or nothing
		} else {
		}
	};
</script>

<ControlsContainer class={className} color={$showNewLayout ? 'color-0' : undefined}>
	<svelte:fragment slot="first">
		{#if $showNewLayout}
			<DeviceButtonV2
				id="devicebutton-zncnpao"
				aria-label={$format('button_mute', { default: 'Mute' })}
				variant="primary"
				size={'l'}
				icon={'fa fa-volume-mute'}
				isActive={isMuted}
				disabled={(hasAlarm && isMuted) || !hasAlarm}
				on:click={muteAlarm}
			/>
		{:else}
			<DeviceButton
				id="devicebutton-zncnpao"
				aria-label={$format('button_mute', { default: 'Mute' })}
				variant="primary"
				size={'l'}
				icon={'fa fa-volume-mute'}
				isActive={isMuted}
				disabled={(hasAlarm && isMuted) || !hasAlarm}
				on:click={muteAlarm}
			/>
		{/if}

		<Text class="text-bold mt-s-plus">{$format('label_mute', { default: 'Mute' })}</Text>
	</svelte:fragment>
</ControlsContainer>
